var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"transparent","flat":""}},[_c('event-cards',{attrs:{"events":_vm.current,"loading":_vm.loading,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }